/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HomerunConnectionSecretsFromJSON, HomerunConnectionSecretsToJSON, } from './HomerunConnectionSecrets.js';
import { IntegrationTypeFromJSON, IntegrationTypeToJSON, } from './IntegrationType.js';
/**
 * Check if a given object implements the GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets interface.
 */
export function instanceOfGetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsFromJSON(json) {
    return GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsFromJSONTyped(json, false);
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': IntegrationTypeFromJSON(json['type']),
        'data': json['data'] == null ? undefined : HomerunConnectionSecretsFromJSON(json['data']),
    };
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsToJSON(json) {
    return GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsToJSONTyped(json, false);
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': IntegrationTypeToJSON(value['type']),
        'data': HomerunConnectionSecretsToJSON(value['data']),
    };
}
